import { PRIMARY_INDUSTRIES } from '@/constants/industries';

export function isIndustrySupported(industry: string) {
  return (
    typeof Object.values(PRIMARY_INDUSTRIES).find(
      (value) => value.slug === industry
    ) !== 'undefined'
  );
}

export const checkSupportedIndustry = (industry?: string) => {
  if (typeof industry === 'undefined') return;
  if (industry === 'any' || isIndustrySupported(industry)) return industry;
  return;
};

export const getPrimaryIndustryMetadataById = (
  industryId: number | string | undefined | null
) => {
  if (typeof industryId !== 'number' && typeof industryId !== 'string') {
    return {
      slug: '',
      label: '',
    };
  }

  const industry = PRIMARY_INDUSTRIES[industryId.toString()];

  return {
    slug: industry?.slug || '',
    label: industry?.label || '',
  };
};
